import { HttpClient, HttpClientKey, useHttpStore } from '../hooks/use-http-store';

/**
 * An async function that returns the HttpClient instance.
 * @param key {string} The key of the HttpClient to get. Defaults to 'v2'.
 * @returns Promise<HttpClient>
 */
export const getHttpClient = (key: HttpClientKey = 'v2') => {
	return new Promise<HttpClient>((resolve) => {
		const client = useHttpStore.getState()[key];

		if (client) {
			return resolve(client);
		}

		const unsubscribe = useHttpStore.subscribe((state) => {
			const client = state[key];

			if (client) {
				unsubscribe();
				resolve(client);
			}
		});
	});
};
